export default __webpack_public_path__ + "static/media/kangaskhan-box-narrow.e5fae848.png";